export default __webpack_public_path__ + "static/media/bariol_light_italic-webfont.03d39b56.woff";